import { Command } from '@/app/tracking/api';

interface QuizSession {
  id: string
}

export type DeleteQuizSessionTrackingCommandPayload = QuizSession

export const DeleteQuizSessionTrackingCommandName = 'delete-quiz-session' as const;
export type DeleteQuizSessionTrackingCommand =
      Command<typeof DeleteQuizSessionTrackingCommandName, DeleteQuizSessionTrackingCommandPayload>;
